import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import Cert from "../../../images/certificate_template.png";


// Create styles
const styles = StyleSheet.create({
  page: {
    fontSize: "12px",
    fontFamily: "Poppins",
  },
  certificateBGContainer: {
    height: "100%",
    width: "100%",
  },
  certificateNameContianer: {
    position: "absolute",
    top: "33%",
    fontSize: "2.65vw",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    color: "rgb(20, 20, 84)",
    backgroundColor: "transparent",
    marginLeft: -45,
  },
  certificateSubDetails: {
    position: "absolute",
    top: "38.6%",
    textAlign: "center",
    width: "100%",
    fontSize: "1.4vw",
    backgroundColor: "transparent",
    color: "rgb(129, 129, 129)",
    fontStyle: "italic",
    marginLeft: -45,
  },
  certificateEventName: {
    position: "absolute",
    top: "43.5%",
    textAlign: "center",
    width: "100%",
    fontWeight: "bold",
    fontSize: "2.55vw",
    color: "rgb(20, 20, 84)",
    backgroundColor: "transparent",
    marginLeft: -45,
  },
  certificateTopics: {
    position: "absolute",
    top: "55%",
    textAlign: "center",
    width: "100%",
    fontWeight: "bold",
    fontSize: "1.4vw",
    color: "rgb(129, 129, 129)",
    backgroundColor: "transparent",
    fontStyle: "italic",
    marginLeft: -45,
  },
  certificateDate: {
    position: "absolute",
    top: "70.6%",
    textAlign: "center",
    width: "100%",
    fontSize: "1.4vw",
    backgroundColor: "transparent",
    color: "rgb(129, 129, 129)",
    fontStyle: "italic",
    marginLeft: -45,
  }
});

// Create Document Component
const BulkCertificateAttendance = ({ names = [], title = "", topics = [], subDetails, datesDetails }) => {
  const certBGLink = "http://petros-global.com/uploads/templates/certificate_of_attendance_v2.png";
  return (
    <Document>
      {names.map(item => (
        <Page size={{ width: 2100, height: 1545 }} style={styles.page}>
          <View style={styles.certificateBGContainer}>
            <Image src={Cert} style={styles.certificateBG} />
          </View>
          <View style={styles.certificateNameContianer}>
            <Text>{item}</Text>
          </View>
  
          <View style={styles.certificateSubDetails}>
            <Text>{subDetails}</Text>
          </View>
  
          <View style={styles.certificateEventName}>
            <Text>{title}</Text>
          </View>
  
          <View style={styles.certificateTopics}>
            {topics.map(topic => (
              <Text>{topic}</Text>
            ))}
          </View>
  
          <View style={styles.certificateDate}>
            <Text>{datesDetails}</Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default BulkCertificateAttendance;